export default __webpack_public_path__ + "static/media/YAS0840.34I-37997_-25183_0.7b6e5c92.jpg";